<template>
  <v-dialog v-model="dialog" max-width="500">
    <!-- 방문 예약 삭제 다이올로그 창 열기 -->
    <v-card v-if="cDelCase == 'Visit'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          방문예약 신청 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <p class="mb-2">신청번호 : {{DelItem.sNum}}</p>
        <p class="mb-2">신청자 : {{DelItem.cCustomNm}}</p>
        <p class="mb-4">담당자 : {{DelItem.cChargeUserNm}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelReqLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>


    <!-- 방문증 분실 신고 삭제 다이올로그 창 -->
    <v-card v-if="cDelCase == 'Pass'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          방문증 분실 신고 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <p class="mb-2">신청번호 : {{DelItem.sNum}}</p>
        <p class="mb-2">분실날짜 : {{DelItem.cLostDateTime.substring(0,10)}}</p>
        <p class="mb-4">방문증번호 : {{DelItem.cPassNm}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelPassLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>


    <!-- 업체물품 반입 신고 삭제 다이올로그 창 -->
    <v-card v-if="cDelCase == 'Carry'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          업체물품 반입 신청 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <p class="mb-2">신청번호 : {{DelItem.sNum}}</p>
        <p class="mb-2">반입 물품 : {{getLabelName(DelItem.cLabel)}}</p>
        <p class="mb-4">반입 장소 : {{DelItem.cZone}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelCorCarryLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>


    <!-- 사진촬영 허가 신청 삭제 다이올로그 창 -->
    <v-card v-if="cDelCase == 'Photo'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          사진촬영 허가 신청 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <p class="mb-2">신청번호 : {{DelItem.sNum}}</p>
        <p class="mb-2">촬영자 : {{DelItem.cCustomNm}}</p>
        <p class="mb-6">담당자 : {{DelItem.cChargeUserNm}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelPhotoPerLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>


    <!-- 카메라 대여 신청 삭제 다이올로그 창 -->
    <v-card v-if="cDelCase == 'Camera'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          카메라 대여 신청 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <p class="mb-2">신청번호 : {{DelItem.sNum}}</p>
        <p class="mb-2">촬영자 : {{DelItem.cCustomNm}}</p>
        <p class="mb-6">담당자 : {{DelItem.cChargeUserNm}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelCameraPerLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>


    <!-- 소속업체 변경 신청 삭제 허가 신청 삭제 다이올로그 창 -->
    <v-card v-if="cDelCase == 'Move'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          소속업체 변경 신청 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <p class="mb-2">담당자 : {{DelItem.cChargeUserNm}}</p>
        <p v-if="DelItem.cMoveLocal == 'Y'" class="mb-2">변경할 업체 : {{DelItem.cMoveCorpNmKor}}</p>
        <p v-else class="mb-2">변경할 업체 : {{DelItem.cMoveCorpNmEng}}</p>
        <p class="mb-6">촬영자 : {{DelItem.cCustomNm}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelMoveCorpLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>
    
    <v-card v-if="cDelCase == 'ChangeCM'" flat tile>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-2 font-weight-bold" style="min-width:140px;">
          협력업체 관리자 신청 내역을 삭제하시겠습니까?
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pa-4 pb-0">
        <!-- <p class="mb-2">신청번호 : {{DelItem.sNum}}</p> -->
        <p class="mb-2">담당자 : 윤영남</p>
        <p class="mb-6">신청자 : {{DelItem.cCustomNm}}</p>
        <v-divider></v-divider>
        <v-col cols="12" align="right" class="pr-0">
          <v-btn @click="dialog = false;DelIndex = -1;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="DelChangeCorpManagerLog()" dark class="ml-2"><v-icon class="mr-1">delete</v-icon>삭제</v-btn>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },

  data: () => ({
    dialog : false,
    cDelCase : "",
    DelIndex : -1,
    DelItem : {
      sNum : 0,
      cReqId : "",
      cUserNm : "",
      cCustomNm : "",
      cChargeUserNm : "",
      cCustomId : "",
      cLostDateTime : "",
      cPassId : "",
      cLabel : "",
      cZone : "",
      iPhotoPerId : "",
      cMoveLocal : "",
      cMoveCorpNmKor : "",
      cMoveCorpNmEng : "",
    },
  }),
  computed: {
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy () {
  },

  methods : {
    // 삭제 다이올로그 창 열기
    ShowDialog(cCase,data,index) {
      this.dialog = true
      this.cDelCase = cCase
      this.DelItem = data
      this.DelIndex = index
    },

    // 방문 신청 현황 삭제하기
    DelReqLog() {
      this.dialog = false;
      this.$emit("DelData",this.DelIndex,this.DelItem)
    },
    
    // 방문증 분실 신청 현황 삭제하기
    DelPassLog() {
      this.dialog = false;
      this.$emit("DelPassData",this.DelIndex,this.DelItem)
    },
    
    // 업체물품 반입 신청 현황 삭제하기
    DelCorCarryLog() {
      this.dialog = false;
      this.$emit("DelCarryData",this.DelIndex,this.DelItem)
    },

    // 사진촬영 허가 신청 현황 삭제하기
    DelPhotoPerLog() {
      this.dialog = false;
      this.$emit("DelPhotoData",this.DelIndex,this.DelItem)
    },

    
    
    DelMoveCorpLog() {
      this.dialog = false;
      this.$emit("DelMoveCorpData",this.DelIndex,this.DelItem)
    },
    
    DelChangeCorpManagerLog() {
      this.dialog = false;
      this.$emit("DelChangeManagerData",this.DelIndex,this.DelItem)
    },

    // 카메라 대여 신청 현황 삭제하기
    DelCameraPerLog() {
      this.dialog = false;
      this.$emit("DelCameraPerLog",this.DelIndex,this.DelItem)
    },
   
    getLabelName(cLabel) {
      const labelMap = {
        "1": "전산기기",
        "2": "디지털카메라",
        "3": "지입자재",
      };
      return labelMap[cLabel] 
    },
  }
}
</script>